import React, { useState } from "react";
import FooterUI from "./FooterUI";

// WhatsApp support handler
  const handleWhatsAppSupport = () => {
    const waShortLink = "https://wa.me/message/LNAEOJV5FWMQI1";
    window.open(waShortLink, "_blank", "noopener,noreferrer");
  };
  
export default function Footer() {
  const [email, setEmail] = useState("");
  const [isNewsletterEnabled, setIsNewsletterEnabled] = useState(false);
  

  const ENAMAD_IMAGE_URL = process.env.REACT_APP_ENAMAD_IMAGE_URL;
  const ENAMAD_LINK = process.env.REACT_APP_ENAMAD_LINK;
  const FALLBACK_IMAGE = "/enamad.png";

  const [imageSrc, setImageSrc] = useState(
    () => ENAMAD_IMAGE_URL || FALLBACK_IMAGE,
  );

  const handleImageError = (event) => {
    const failedImage = event.currentTarget.src;
    const fallbackUrl = new URL(FALLBACK_IMAGE, window.location.href).href;

    // If the fallback also fails, do not retry it forever.
    if (failedImage !== fallbackUrl) {
      setImageSrc(FALLBACK_IMAGE);
    }
  };


  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (!email) return;
    setEmail("");
  };



  const contactInfo = {
    phone: "09221569470",
    phoneRaw: "09221569470",
    email: process.env.REACT_APP_SUPPORT_EMAIL,
  };

  const quickAccessLinks = [
  {
    text: "تماس با ما",
    onClick: handleWhatsAppSupport,
  },
  { text: "پاسخ سوالات متداول", href: "/faq" },
  { text: "نحوه ثبت سفارش", href: "/condition" },
];


  const currentYear = new Date().getFullYear();

  return (
    <FooterUI
      email={email}
      handleEmailChange={handleEmailChange}
      handleNewsletterSubmit={handleNewsletterSubmit}
      quickAccessLinks={quickAccessLinks}
      contactInfo={contactInfo}
      currentYear={currentYear}
      isNewsletterEnabled={isNewsletterEnabled}
      imageSrc={imageSrc}
      handleImageError={handleImageError}
      enamadLink={ENAMAD_LINK}
      
      
    />
  );
}
